<template>
  <div>
    <div class="gpt_container" v-loading="fullScreenLoading">
      <el-container>
        <el-main>
          <img src="../../assets/imgs/openai-logo.png" alt="" class="logo">
          <el-row class="functional_area">
            <el-button :type="boxShow == 'Chat' ? 'primary' : ''" @click="toggleAIView('Chat')">Chat</el-button>
            <!-- <el-button :type="boxShow == 'Edit' ? 'primary' : ''" @click="toggleAIView('Edit')">Edit</el-button> -->
          </el-row>
        </el-main>
      </el-container>
      <el-container v-show="boxShow === 'Chat'">
        <el-main>
          <template>
            Switch AI Model:
            <el-radio-group v-model="AI_model">
              <el-radio label="Douyin" border>豆包</el-radio>
              <el-radio label="DeepSeek" border>DeepSeek</el-radio>
              <el-radio label="ChatGPT" border disabled>ChatGPT</el-radio>
            </el-radio-group>
          </template>
          <div class="chat_container" v-loading="chatLoading" element-loading-text="Waiting for answer...">
            <div class="chat_box" ref="chatBox">
              <div v-for="(items, key) in messages" :key="key" :class="'msg_' + items.who" class="chat_messages">
                <div class="message_box">
                  {{ items.message }}
                </div>
              </div>
            </div>
            <div class="ask_me">
              <el-form :model="chatForm" :rules="chatRules" ref="chatForm">
                <el-form-item label="" prop="q">
                  <el-input type="textarea" v-model="chatForm.q"
                    placeholder="You can ask me anything, press Ctrl + Enter to send" resize="none"
                    :disabled="chatFormQuestionDisable" @keydown.native="chatFormKeyDown"></el-input>
                  <i class="el-icon-position" @click="chat()" title="send"></i>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-main>
      </el-container>

      <el-container v-show="boxShow === 'Edit'">
        <el-main>
          <template>
          </template>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import Nav from '../Global/Nav.vue'
export default {
  name: 'ChatGPT',
  components: {
    Nav
  },
  data() {
    return {
      boxShow: 'Chat',
      // boxShow: 'Edit',
      fullScreenLoading: false,
      AI_model: 'Douyin',
      models: [],
      chatLoading: false,
      messages: [],
      chatForm: {
        q: ''
      },
      chatRules: {
        q: [
          { required: true, message: 'The question can not be empty', trigger: 'commit' },
          { min: 1, max: 1000, message: 'The question should be between 1 and 1000 characters in length', trigger: 'commit' }
        ]
      },
      chatFormQuestionDisable: false
    }
  },
  mounted() {
    // this.getModels()
  },
  methods: {
    getModels() {
      this.fullScreenLoading = true;
      let that = this;
      this.$axios.get('/chatgpt/models')
        .then(function (response) {
          if (response.data.code === 200) {
            that.models = response.data.data;
            that.fullScreenLoading = false;
          }
        });
    },
    connectModel(v) {
      this.AI_model = v
    },
    toggleAIView(v) {
      this.boxShow = v
    },
    chat() {
      this.$refs.chatForm.validate(valid => {
        if (valid) {
          this.chatLoading = true;
          // this.chatFormQuestionDisable = true;
          let history = "";
          this.messages.forEach((val) => {
            if (val.who === 'user') {
              // 只记录用户的信息
              history += val.message + ","
            }
          })
          let q = this.chatForm.q;
          let that = this;
          let msg = {
            'who': 'user',
            'message': q,
            'type': 'message'
          }
          this.messages.push(msg);
          this.chatForm.q = '';
          this.$axios.post('/chatgpt/chat', {
            q: q,
            history: history
          }).then(function (response) {
            that.chatLoading = false;
            if (response.data.code === 200) {
              let msg = {
                'who': 'ai',
                'message': '',
                'type': 'message'
              }
              that.messages.push(msg);
              let box = that.$refs.chatBox
              for (let i = 0; i < response.data.data.length; i++) {
                // 逐字打印的效果
                setTimeout(() => {
                  that.messages[that.messages.length - 1].message += response.data.data[i].choices[0].message.content || '';
                  box.scrollTop = box.scrollHeight
                }, i * 100)
              }
            }
            that.chatFormQuestionDisable = false;
          });
        }
      })
    },
    chatFormKeyDown(event) {
      if (event.ctrlKey && event.keyCode === 13) {
        this.chat();
      }
    }
  }
}
</script>

<style scoped>
.logo {
  width: 40px;
  position: absolute;
  animation: spin 25s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(360deg);
  }

  to {
    transform: rotate(0deg);
  }
}

.gpt_container {
  width: 100%;
  /* padding: 0 20px; */
  height: calc(100vh - 95px);
}

.functional_area {
  margin-left: 60px;
}

.chat_container {
  width: 40%;
  padding: 0 20px;
  height: calc(100vh - 280px);
  margin-top: 20px;
  border: solid 1px #DCDFE6;
  border-radius: 10px;
}

.chat_box {
  width: 100%;
  height: calc(100% - 150px);
  overflow: auto;
}

.chat_box::-webkit-scrollbar {
  display: none;
}

.chat_messages {
  max-width: 100%;
  margin: 20px 0;
}

.msg_user {
  display: flex;
  align-items: end;
  justify-content: end;
}

.msg_ai {
  display: flex;
  align-items: start;
  justify-content: start;
}

.message_box {
  max-width: 50%;
  word-wrap: break-word;
  line-height: 28px;
  font-size: 14px;
}

.msg_user .message_box {
  background: #409EFF;
  border: solid 1px #409EFF;
  border-radius: 8px 8px 0 8px;
  padding: 0 10px;
  color: #FFF;
}

.msg_ai .message_box {
  background: #F6F8FA;
  border: solid 1px #DCDFE6;
  border-radius: 8px 8px 8px 0;
  padding: 0 10px;
}

.ask_me {
  width: 100%;
  height: 150px;
}

.ask_me /deep/ textarea {
  height: 130px;
  overflow: auto;
}

.ask_me /deep/ textarea::-webkit-scrollbar {
  display: none;
}

.ask_me /deep/ i {
  position: absolute;
  top: 100px;
  right: 20px;
  font-size: 20px;
}

.ask_me /deep/ i:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/ChatGPT.vue